import { reportSGM, isJDAPP, isJRAPP } from '@jdt-jinke/jdpay_utils'
import router from '@/router'
import type { RouteLocationRaw } from 'vue-router'
import { queryPurify, formatUrlParams } from './params'

/** 返回上一页 */
export function jumpBack(webview?: boolean) {
  // 如果是webview，需要关掉 webview
  if (webview) {
    closeWebview()
  } else {
    router.back()
  }
}

/** 重置页面参数 */
export function resetPageQuery(query: Record<string, any>) {
  router.replace({
    query: queryPurify(query || {})
  })
}

/** 原生页面跳转 */
export function jumpNative({
  name = '',
  routeType = 'push',
  query = {}
}: {
  name?: string
  routeType?: 'push' | 'replace'
  query?: Record<string, any>
}) {
  // 如果没有 routeName，直接返回
  if (!name) return

  // 获取路由跳转方法
  const jumpFn = router[routeType] as (
    location: RouteLocationRaw
  ) => Promise<void>

  // 如果跳转方法是函数，执行跳转
  if (typeof jumpFn === 'function') {
    jumpFn({ name, query: queryPurify(query, 'jumpNative') })
  }
}

/**
 * 跳转外链
 * @param {*} url
 * @returns {undefined}
 */
export function jumpUrl(
  url = '',
  {
    functionName = '',
    webview = false,
    routeType = 'push',
    data
  }: {
    data?: any
    functionName?: string
    webview?: boolean
    routeType?: 'push' | 'replace'
  }
) {
  console.log('jumpUrl', url)

  if (!url) {
    return reportSGM({
      code: `jumpUrl_empty${functionName ? '_' + functionName : ''}`,
      res: { data }
    })
  }

  try {
    if (webview && isJDAPP && !/openapp/i.test(url)) {
      const encodedParam = encodeURIComponent(
        `{"category":"jump","des":"m","url":"${formatUrlParams(url, {
          jdWebview: 1
        })}"}`
      )
      console.log(
        '跳转链接',
        `openapp.jdmobile://virtual?params=${encodedParam}`
      )
      window.location.href = `openapp.jdmobile://virtual?params=${encodedParam}`
    } else {
      if (routeType === 'replace') {
        location.replace(url)
      } else {
        location.href = url
      }
    }
  } catch (error) {
    reportSGM({
      code: `jumpUrl_error`,
      res: { functionName, url },
      err: error
    })
    location.href = url
  }
}

/**
 * 关闭Webview的函数。
 * 尝试执行关闭操作，如果发生错误则上报错误信息。
 * @throws {Error} 如果关闭操作失败，将捕获并上报错误。
 */
export function closeWebview() {
  try {
    if (isJDAPP) {
      window.location.href = 'closeJDApp://webview'
    } else if (isJRAPP) {
      JrBridge?.closeView()
    }
  } catch (err) {
    // 告警
    reportSGM({
      code: 'closeWebview_catch',
      err
    })
    // 使用浏览器自带的关闭方法
    window.history.back()
  }
}
